import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "survey" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Your Info", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Your Network", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Interactions", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Relationships", -1)
const _hoisted_8 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SurveyMainPage = _resolveComponent("SurveyMainPage")!
  const _component_n_step = _resolveComponent("n-step")!
  const _component_n_steps = _resolveComponent("n-steps")!
  const _component_SurveyYourInfo = _resolveComponent("SurveyYourInfo")!
  const _component_SurveyYourNetwork = _resolveComponent("SurveyYourNetwork")!
  const _component_SurveyInteractions = _resolveComponent("SurveyInteractions")!
  const _component_SurveyRelationships = _resolveComponent("SurveyRelationships")!
  const _component_SurveyThankYou = _resolveComponent("SurveyThankYou")!
  const _component_SurveyButtons = _resolveComponent("SurveyButtons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.current === _ctx.SURVEY_TABS.MAIN_PAGE && !_ctx.completedSurvey)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_SurveyMainPage, {
            name: _ctx.surveyState.data?.name,
            introduction: _ctx.surveyState.data?.details.introduction,
            benefits: _ctx.surveyState.data?.details.benefits,
            confidentiality: _ctx.surveyState.data?.details.confidentiality,
            participation: _ctx.surveyState.data?.details.participation,
            questions: _ctx.surveyState.data?.details.questions,
            hasAgreed: _ctx.userHasAgreed,
            "onUpdate:hasAgreed": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userHasAgreed) = $event))
          }, null, 8, ["name", "introduction", "benefits", "confidentiality", "participation", "questions", "hasAgreed"])
        ]))
      : (_ctx.current > _ctx.SURVEY_TABS.MAIN_PAGE && _ctx.current <= _ctx.SURVEY_TABS.RELATIONSHIPS)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_n_steps, {
              current: (_ctx.current as number),
              status: _ctx.currentStatus
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_step, null, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_step, null, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_step, null, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_step, null, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["current", "status"]),
            (_ctx.current === _ctx.SURVEY_TABS.YOUR_INFO)
              ? (_openBlock(), _createBlock(_component_SurveyYourInfo, {
                  key: 0,
                  ref: "yourInfo",
                  name: _ctx.responseEditingState.info.name,
                  "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.responseEditingState.info.name) = $event)),
                  email: _ctx.responseEditingState.info.email,
                  "onUpdate:email": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.responseEditingState.info.email) = $event)),
                  role: _ctx.responseEditingState.info.role,
                  "onUpdate:role": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.responseEditingState.info.role) = $event)),
                  organization: _ctx.responseEditingState.info.organization,
                  "onUpdate:organization": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.responseEditingState.info.organization) = $event)),
                  organizationType: _ctx.responseEditingState.info.organizationType,
                  "onUpdate:organizationType": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.responseEditingState.info.organizationType) = $event)),
                  zipCode: _ctx.responseEditingState.info.zipCode,
                  "onUpdate:zipCode": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.responseEditingState.info.zipCode) = $event)),
                  participationInNetwork: _ctx.responseEditingState.info.participationInNetworkType,
                  "onUpdate:participationInNetwork": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.responseEditingState.info.participationInNetworkType) = $event)),
                  organizationTypeList: _ctx.mappedOrganizationTypeList,
                  participationInNetworkList: _ctx.mappedParticipationNetworkTypeList,
                  participationInNetworkQuestion: _ctx.computedParticipationNetworkQuestion ? _ctx.computedParticipationNetworkQuestion : 'Participation In Network:'
                }, null, 8, ["name", "email", "role", "organization", "organizationType", "zipCode", "participationInNetwork", "organizationTypeList", "participationInNetworkList", "participationInNetworkQuestion"]))
              : (_ctx.current === _ctx.SURVEY_TABS.YOUR_NETWORK)
                ? (_openBlock(), _createBlock(_component_SurveyYourNetwork, {
                    key: 1,
                    ref: "yourNetwork",
                    text: (_ctx.surveyState.data?.questions?.network?.text as string),
                    maxEntries: (_ctx.surveyState?.data?.questions.network.maximumEntries as number),
                    yourNetwork: _ctx.responseState.data!.network.yourNetwork,
                    "onUpdate:yourNetwork": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.responseState.data!.network.yourNetwork) = $event)),
                    "network-type": (_ctx.surveyState.data?.questions.network.networkType as NetworkType),
                    organizationTypeList: _ctx.mappedOrganizationTypeList as SelectOption[]
                  }, null, 8, ["text", "maxEntries", "yourNetwork", "network-type", "organizationTypeList"]))
                : (_ctx.current === _ctx.SURVEY_TABS.INTERACTIONS)
                  ? (_openBlock(), _createBlock(_component_SurveyInteractions, {
                      key: 2,
                      ref: "interactions",
                      yourNetwork: _ctx.responseState.data!.network.yourNetwork,
                      "onUpdate:yourNetwork": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.responseState.data!.network.yourNetwork) = $event)),
                      text: _ctx.surveyState.data?.questions.interactions.text,
                      options: _ctx.surveyState.data!.questions.interactions.options,
                      userId: _ctx.userId
                    }, null, 8, ["yourNetwork", "text", "options", "userId"]))
                  : (_openBlock(), _createBlock(_component_SurveyRelationships, {
                      key: 3,
                      ref: "relationships",
                      yourNetwork: _ctx.responseState.data!.network.yourNetwork,
                      "onUpdate:yourNetwork": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.responseState.data!.network.yourNetwork) = $event)),
                      text: _ctx.surveyState.data?.questions.relationships.text,
                      options: _ctx.surveyState.data!.questions.relationships.options,
                      userId: _ctx.userId
                    }, null, 8, ["yourNetwork", "text", "options", "userId"]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_SurveyThankYou)
          ])),
    (!_ctx.completedSurvey)
      ? (_openBlock(), _createBlock(_component_SurveyButtons, {
          key: 3,
          finishButton: _ctx.current === _ctx.SURVEY_TABS.RELATIONSHIPS,
          continueButton: _ctx.current < _ctx.SURVEY_TABS.RELATIONSHIPS,
          backButton: _ctx.current > _ctx.SURVEY_TABS.MAIN_PAGE && _ctx.current <= _ctx.SURVEY_TABS.RELATIONSHIPS,
          hasAgreed: _ctx.userHasAgreed,
          "onUpdate:hasAgreed": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userHasAgreed) = $event)),
          onFinishClick: _ctx.submitSurvey,
          onContinueClick: _ctx.showNext,
          onBackClick: _ctx.showPrev
        }, null, 8, ["finishButton", "continueButton", "backButton", "hasAgreed", "onFinishClick", "onContinueClick", "onBackClick"]))
      : _createCommentVNode("", true)
  ]))
}